module.exports = __webpack_public_path__ + "static/media/tt.7d37ab30.webp";